import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@mui/material/styles';
import { formatDate } from '../common/helpers.js';
import Organizers from '../organisers/Organizers.jsx';
import { fonts, links } from '../common/mixins.js';
import Overlay from "../common/Overlay";
import useModal from "../../hooks/useModal";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: ${({ hasProducts }) => (hasProducts ? '16px' : '-8px')};
`;

const FlexContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const DarkLink = styled.a`
  ${links.linkSmallBrightPurple()}; 
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
`;

const Light = styled.div`
  font-family: 'pf_highway_sans_pro_lightRg';
  font-size:14px;
  font-weight:400;
  color: #4C4969;
  flex-shrink: 0;
`;

const Small = styled.div`
 ${fonts.normalTextSmall()}; 
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ReservationOrganizer = ({ date, culture, organizer, organiserData, hasProducts = false }) => {
    const theme = useTheme();
    const { isOpen, openModal, closeModal } = useModal();

    const formattedDateTime = formatDate({ date, culture });
 
    return (
        <>
            <Container hasProducts={hasProducts}>
                <FlexContainer>
                    <Light>{orderdetails_resources.Organiser}</Light>
                    <DarkLink onClick={(e) => {
                        e.preventDefault();
                        openModal();
                    }}>{organizer}</DarkLink>
                </FlexContainer>
                <FlexContainer>
                    <Light>{orderdetails_resources.ReservationDate}</Light>
                    <Small>{formattedDateTime}</Small>
                </FlexContainer>
            </Container>
            <Overlay
                handleClose={closeModal}
                open={isOpen}
                id="order-details-organizers"
                titleText={playdetailsv2_resources.Organizer}
            >
               <Organizers organiserData={organiserData} />
            </Overlay>
        </>
    );
};

export default ReservationOrganizer;
